import React from "react";
import { Link } from "react-router-dom";

const INSTAGRAM_HANDLE = "@cineglimpsestories";
const INSTAGRAM_URL = "https://instagram.com/cineglimpsestories";
const INQUIRY_EMAIL = "cineglimpsestories@gmail.com";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-ink-ivory/10 bg-[#15110F]">
      <div className="px-6 md:px-12 lg:px-16 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-10">
        <div className="md:col-span-5">
          <Link to="/" aria-label="Cineglimpse Stories — home" className="block">
            <div
              className="h-20 md:h-24 w-72 md:w-96 bg-no-repeat bg-center"
              style={{
                backgroundImage:
                  "url('https://customer-assets.emergentagent.com/job_luxury-wedding-films-16/artifacts/lubzfoaa_2.png')",
                backgroundSize: "cover",
              }}
            />
          </Link>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-ink-ivory/70">
            A studio of wedding films and editorial photography. Quiet, cinematic,
            timeless storytelling for couples who collect moments like artefacts.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-[10px] tracking-[0.32em] uppercase text-ink-taupe mb-6">Navigate</p>
          <ul className="space-y-3 text-sm text-ink-ivory/80">
            <li><Link to="/films" className="editorial-link" data-testid="footer-link-films">Films</Link></li>
            <li><Link to="/gallery" className="editorial-link" data-testid="footer-link-gallery">Gallery</Link></li>
            <li><Link to="/testimonials" className="editorial-link" data-testid="footer-link-testimonials">Testimonials</Link></li>
            <li><Link to="/contact" className="editorial-link" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-[10px] tracking-[0.32em] uppercase text-ink-taupe mb-6">Studio</p>
          <ul className="space-y-3 text-sm text-ink-ivory/80">
            <li>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="editorial-link"
                data-testid="footer-instagram-link"
              >
                Instagram · {INSTAGRAM_HANDLE}
              </a>
            </li>
            <li>
              <a href={`mailto:${INQUIRY_EMAIL}`} className="editorial-link" data-testid="footer-email-link">
                {INQUIRY_EMAIL}
              </a>
            </li>
            <li>
              <Link to="/contact" className="editorial-link" data-testid="footer-cta-inquire">
                Begin an inquiry →
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="px-6 md:px-12 lg:px-16 py-6 border-t border-ink-ivory/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
        <p className="text-[10px] tracking-[0.32em] uppercase text-ink-taupe">
          © {new Date().getFullYear()} Cineglimpse Stories · All Rights Reserved
        </p>
        <p className="text-[10px] tracking-[0.32em] uppercase text-ink-taupe/70">
          Exhibition catalogue · Volume I
        </p>
      </div>
    </footer>
  );
}
